import { FieldList } from '../FieldList/FieldList';
import type { LabelValueField } from '../LabelValueFields/LabelValueFields';

interface Props {
  profileEducation?: Array<{
    name: string;
    isVerified?: boolean;
    institute?: string;
    completionLabel?: string;
    highlights?: string | null;
    labelValueFields?: LabelValueField[];
  }>;
}

export const Education = ({ profileEducation }: Props) => (
  <FieldList
    icon="education"
    iconTone="info"
    descriptionSize="smallMobile"
    fields={
      profileEducation && profileEducation.length > 0
        ? profileEducation.map(
            ({
              name,
              institute,
              completionLabel,
              highlights,
              isVerified,
              labelValueFields,
            }) => ({
              heading: name,
              subHeading: institute,
              subHeadingSecondary: completionLabel,
              ...(typeof highlights === 'string' &&
                highlights.length > 0 && { description: highlights }),
              isVerified,
              labelValueFields,
            }),
          )
        : []
    }
  />
);
